import { t } from '../i18n';
import { GUARD, type Guard } from '../config/constants';

/** Display name for a guardia (d'arte term, stays Italian). */
export function guardLabel(g: Guard): string {
  switch (g) {
    case GUARD.portaDiFerroStretta:
      return t('guardPdfStretta');
    case GUARD.portaDiFerroLarga:
      return t('guardPdfLarga');
    case GUARD.codaLungaStretta:
      return t('guardClStretta');
    case GUARD.codaLungaAlta:
      return t('guardClAlta');
    case GUARD.codaLungaLarga:
      return t('guardClLarga');
    case GUARD.codaLungaDistesa:
      return t('guardClDistesa');
  }
}
